import Disclosure from '@pixelunion/shopify-cross-border';

export default class StaticFooter {
  constructor(section) {
    this.el = section.el;
    this.countryDisclosureEls = this.el.querySelectorAll('[data-disclosure-country]');
    this.localeDisclosureEls = this.el.querySelectorAll('[data-disclosure-locale]');
    this.disclosures = [];

    if (this.countryDisclosureEls.length > 0) {
      this.countryDisclosureEls.forEach(disclosureEl => {
        this.disclosures.push(new Disclosure(disclosureEl));
      });
    }

    if (this.localeDisclosureEls.length > 0) {
      this.localeDisclosureEls.forEach(disclosureEl => {
        this.disclosures.push(new Disclosure(disclosureEl));
      });
    }
  }

  onSectionUnload() {
    this.disclosures.forEach(disclosure => disclosure.unload());
  }
}
